import React from 'react';

const stepsData = [
  {
    num: "01",
    title: "Solicita tu Servicio",
    desc: "Envíanos las pautas de tu actividad por WhatsApp. Lo revisamos e iniciamos de inmediato.",
    badge: "Respuesta en 30 min",
    colorClass: "text-blue-600 border-blue-100 bg-blue-50/30",
    numGlow: "bg-blue-600 shadow-blue-200",
    textGlow: "text-blue-600/10",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a.75.75 0 01-1.074-.765 6 6 0 013.01-4.726C4.64 14.189 3 12.054 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
      </svg>
    )
  },
  {
    num: "02",
    title: "Recibe tu Cotización",
    desc: "Te asignamos el tutor experto ideal y te enviamos el presupuesto personalizado al instante.",
    badge: "Precio Justo Garantizado",
    colorClass: "text-emerald-600 border-emerald-100 bg-emerald-50/30",
    numGlow: "bg-emerald-500 shadow-emerald-200",
    textGlow: "text-emerald-500/10",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75m0 .75h-.75m.75 0v1.5m0 3h-.75m.75 0v1.5m0 3h-.75m.75 0V18m0 0h-.75m.75 0v1.5m16.5-1.5h.75m-.75 0v-1.5m0-3h.75m-.75 0v-1.5m0-3h.75m-.75 0V6.75m0 0h.75m-.75 0V4.5M12 9a3 3 0 100-6 3 3 0 000 6zm0 0v6m0 0a3 3 0 100 6 3 3 0 000-6zm0 0H6m6 0h6" />
      </svg>
    )
  },
  {
    num: "03",
    title: "Realiza el Pago",
    desc: "Inicia tu proyecto asegurando el cupo con un abono del 50% o el 100% mediante canales seguros.",
    badge: "Transacción Protegida",
    colorClass: "text-purple-600 border-purple-100 bg-purple-50/30",
    numGlow: "bg-purple-600 shadow-purple-200",
    textGlow: "text-purple-600/10",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
      </svg>
    )
  },
  {
    num: "04",
    title: "Desarrollo Humano",
    desc: "Tu tutor redacta y ejecuta el entregable bajo control estricto de pautas y avance continuo.",
    badge: "100% Humano (Anti-IA)",
    colorClass: "text-amber-600 border-amber-100 bg-amber-50/30",
    numGlow: "bg-amber-500 shadow-amber-200",
    textGlow: "text-amber-500/10",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.59 2.5a14.98 14.98 0 00-6.16 12.11c0 .29.007.58.021.87m12.13-1.11v.008zm-2.25 1.74v.008z" />
      </svg>
    )
  },
  {
    num: "05",
    title: "Filtro e Informe Final",
    desc: "Pasamos tu documento por Turnitin Premium. Revisas la entrega impecable y liquidas el saldo.",
    badge: "Certificado Anti-Plagio",
    colorClass: "text-rose-600 border-rose-100 bg-rose-50/30",
    numGlow: "bg-rose-500 shadow-rose-200",
    textGlow: "text-rose-500/10",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
      </svg>
    )
  }
];

const Process = () => {
  return (
    <section id="comoTrabajamos" className="py-16 px-6 lg:px-16 bg-white text-center overflow-hidden">
      
      <span className="inline-flex items-center gap-1.5 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
        </svg>
        Flujo de Trabajo
      </span>
      
      <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
        ¿Cómo <span className="text-blue-600">Trabajamos</span>?
      </h2>
      <p className="text-slate-500 mt-2 text-sm md:text-base max-w-xl mx-auto">
        Diseñamos un sistema transparente de 5 pasos para garantizar tu tranquilidad académica.
      </p>

      {/* CONTENEDOR INFOGRÁFICO CON LÍNEA DE PROGRESO DE FONDO */}
      <div className="relative mt-20 max-w-7xl mx-auto">
        
        {/* LÍNEA CONECTORA CONTINUA */}
        <div className="hidden lg:block absolute top-[28px] left-[10%] right-[10%] h-0.5 bg-slate-100 z-0" />

        {/* GRID DE PASOS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 relative z-10">
          {stepsData.map((step, idx) => (
            <div 
              key={idx} 
              className="flex flex-col items-center group relative"
            >
              {/* NÚMERO FLOTANTE MASIVO */}
              <div className={`absolute -top-10 font-black text-7xl select-none transition-transform duration-300 group-hover:scale-110 ${step.textGlow}`}>
                {step.num}
              </div>

              {/* CIRCULO INDICADOR CON ICONO */}
              <div className={`w-14 h-14 rounded-full flex items-center justify-center text-white border-4 border-white shadow-md relative z-20 transition-all duration-300 transform group-hover:scale-110 ${step.numGlow}`}>
                {step.icon}
              </div>

              {/* CONTENEDOR DE INFORMACIÓN DE LA TARJETA */}
              <div className={`mt-6 p-5 rounded-2xl border w-full flex flex-col justify-between items-center text-center bg-white transition-all duration-300 group-hover:shadow-xl group-hover:border-slate-200 min-h-[220px] ${step.colorClass}`}>
                
                <div className="space-y-2">
                  <h3 className="text-sm md:text-base font-black text-slate-900 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-slate-500 text-[11px] md:text-xs leading-relaxed font-semibold px-1">
                    {step.desc}
                  </p>
                </div>

                {/* MINI BADGE INTERNO */}
                <span className="text-[9px] font-bold mt-4 tracking-wider uppercase bg-white/90 py-1.5 px-3 rounded-lg border border-inherit shadow-sm block w-full text-slate-700">
                  {step.badge}
                </span>

              </div>

              {/* FLECHAS DE CONEXIÓN RESPONSIVAS INTERMEDIAS */}
              {idx < 4 && (
                <div className="lg:hidden my-3 text-slate-300 font-light text-xl">
                  ↓
                </div>
              )}

            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Process;